import { IconButton, IconButtonProps, styled } from '@mui/material';

export const CerebroIconButton: React.FC<CerebroIconButtonProps> = ({ children, ...props }) => {
	return (
		<StyledIconButton {...props} sx={theme => ({ color: theme.palette.gray.dark, marginLeft: 1.5 })}>
			{children}
		</StyledIconButton>
	);
};

type CerebroIconButtonProps = IconButtonProps;

const StyledIconButton = styled(IconButton)(({ color, theme }) => ({
	color: theme.palette.gray.dark,

	'&:hover': {
		color: color === 'error' ? theme.palette.error.dark : theme.palette.gray.dark,
	},
}));
